import React from 'react';
import Button from '../../Buttons/Button';
import WelcomeVideo from './WelcomeVideo/WelcomeVideo';
import LanguageSelect from 'components/LanguageSelect/LanguageSelect';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import './Welcome.scss';

const Welcome = ({
  closePopUp,
  description,
  myRef,
  name,
  setCustomStyles,
  popUpVideoId,
  enablePopUpVideo,
  videos,
}) => {
  const welcomeClasses = cx({
    'no-desc': !description,
  });
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <h1 className={`tour-name ${welcomeClasses}`}>
        {name}
      </h1>
      {(description || enablePopUpVideo) && (
        <div className="welcome__content-wrapper">
          {description?.replace(/<(.|\n)*?>/g, '').trim() ? (
            <div
              className="tour-desc"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            ></div>
          ) : (
            <h4 className="step-secondary-title">
              {t('publicTour.welcome.tourDescription')}
            </h4>
          )}
          {enablePopUpVideo && (
            <WelcomeVideo popUpVideoId={popUpVideoId} videos={videos} />
          )}
        </div>
      )}
      <Button
        className="start-tour"
        name="startTour"
        handleClick={closePopUp}
        myRef={myRef}
        style={setCustomStyles()}
        data-cy="start-tour"
      >
        <i aria-hidden="true" className="material-icons">
          check_circle
        </i>
        &nbsp; {t('publicTour.welcome.startTourButton')}
      </Button>
      <LanguageSelect id="welcome" classes="welcome-lang-select" />
    </React.Fragment>
  );
};

export default Welcome;
